/* ============================================================
   Vibe Cart Products — behaviour (WonderSkull custom, not stock Shrine PRO).

   Moved out of blocks/vibe-cart-products.liquid so a page carrying two
   instances (cart drawer + mobile menu) ships this once, cached, instead of
   inline in each. Loaded with defer from the block, guarded by window.__wsVCP
   so a second <script> tag for the same asset is a no-op.

   Deferred loading also fixes an ordering subtlety the inline version had:
   the first instance's inline script ran before later instances were parsed,
   so anything it looked up once (deferred images, arrow sync) could miss
   them. With defer, every instance is in the DOM when this runs.
   ============================================================ */
(function () {
  if (window.__wsVCP) return;
  window.__wsVCP = true;
  // Deferred images (defer_images): a card inside the closed menu drawer is
  // translated off-screen, which native loading="lazy" still counts as
  // "near the viewport". An IntersectionObserver with no margin does not,
  // so the request waits for the drawer to actually open.
  (function () {
    var pending = document.querySelectorAll('.vibe-cart-products img[data-vcp-src]');
    if (!pending.length) return;
    var load = function (img) { if (img.dataset.vcpSrc) { img.src = img.dataset.vcpSrc; delete img.dataset.vcpSrc; } };
    if (!('IntersectionObserver' in window)) { pending.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
    });
    pending.forEach(function (img) { io.observe(img); });
  })();
  // Arrow bookkeeping: hide the LEFT arrow at the start of the list and
  // the RIGHT one at the end (both when nothing overflows), and center
  // both on the product IMAGE — its height varies with cards-visible ×
  // aspect-ratio, so it's measured rather than guessed in CSS.
  function vcpUpdateEnds(list) {
    var w = list.closest('.vcp-scroll-wrap');
    if (!w) return;
    var prev = w.querySelector('[data-vcp-arrow="prev"]');
    var next = w.querySelector('[data-vcp-arrow="next"]');
    if (!prev && !next) return;
    var over = list.scrollWidth > list.clientWidth + 2;
    var atStart = list.scrollLeft <= 2;
    var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    if (prev) {
      if (!over || atStart) prev.setAttribute('data-vcp-arrow-hidden', '');
      else prev.removeAttribute('data-vcp-arrow-hidden');
    }
    if (next) {
      if (!over || atEnd) next.setAttribute('data-vcp-arrow-hidden', '');
      else next.removeAttribute('data-vcp-arrow-hidden');
    }
    var media = list.querySelector('[data-vcp-card]:not(.vcp-hidden) .vcp-media');
    if (media) {
      var top = media.getBoundingClientRect().top - w.getBoundingClientRect().top
        + media.getBoundingClientRect().height / 2;
      if (top > 0) {
        if (prev) prev.style.top = top + 'px';
        if (next) next.style.top = top + 'px';
      }
    }
  }
  function vcpSyncArrows() {
    document.querySelectorAll('.vibe-cart-products .vcp-list').forEach(function (list) {
      if (!list.__vcpBound) {
        list.__vcpBound = true;
        var ticking = false;
        list.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            vcpUpdateEnds(list);
          });
        }, { passive: true });
      }
      vcpUpdateEnds(list);
    });
  }
  var vcpArrowTimer = null;
  new MutationObserver(function () {
    clearTimeout(vcpArrowTimer);
    vcpArrowTimer = setTimeout(vcpSyncArrows, 200);
  }).observe(document.body, { childList: true, subtree: true });
  setTimeout(vcpSyncArrows, 400);

  // Arrows and reveal-mode "View more" are role=button spans (see the block
  // for why). Enter and Space must activate them like a real button would.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target.closest && e.target.closest('.vibe-cart-products [role="button"][data-vcp-arrow], .vibe-cart-products [role="button"][data-vcp-more]');
    if (!el) return;
    e.preventDefault();
    el.click();
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    // Carousel arrows: scroll by one card; instant when the visitor
    // prefers reduced motion.
    var arrow = e.target.closest('.vibe-cart-products [data-vcp-arrow]');
    if (arrow) {
      var awrap = arrow.closest('.vcp-scroll-wrap');
      var alist = awrap && awrap.querySelector('.vcp-list');
      if (!alist) return;
      var acard = alist.querySelector('[data-vcp-card]:not(.vcp-hidden)');
      var gap = parseFloat(getComputedStyle(alist).gap) || 12;
      var step = acard ? acard.getBoundingClientRect().width + gap : alist.clientWidth * 0.6;
      var dir = arrow.getAttribute('data-vcp-arrow') === 'prev' ? -1 : 1;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      alist.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    // "View more" (products source): reveal the pre-rendered hidden
    // cards instantly and bring the first one into view.
    var more = e.target.closest('.vibe-cart-products [data-vcp-more]');
    if (more) {
      var wrap = more.closest('.vibe-cart-products');
      var hidden = wrap.querySelectorAll('.vcp-hidden');
      hidden.forEach(function (el) { el.classList.remove('vcp-hidden'); });
      more.style.display = 'none';
      if (hidden[0]) hidden[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      return;
    }
    var btn = e.target.closest('.vibe-cart-products [data-vcp-atc]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('[data-vcp-card]');
    var sel = card && card.querySelector('.vcp-variant');
    var id = Number(sel ? sel.value : btn.getAttribute('data-variant'));
    if (!id) return;
    btn.disabled = true;
    // In-button loading state: freeze the width, swap the label for a
    // spinner. On success the drawer re-render replaces this button
    // wholesale, so the restore below only matters on failure.
    var prevLabel = btn.innerHTML;
    btn.style.boxSizing = 'border-box'; /* offsetWidth includes padding */
    btn.style.width = btn.offsetWidth + 'px';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.innerHTML = reduceMotion
      ? '…'
      : '<svg class="vcp-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9" opacity="0.25"/><path d="M21 12a9 9 0 0 0-9-9"/></svg>';
    // Source tag for OKpixel: the block prints data-vcp-track (see the Liquid
    // for how it is built), sent as a hidden line item property so the order
    // itself proves which drawer block the line was added from.
    var vcpWrap = btn.closest('.vibe-cart-products');
    var vcpSrc = vcpWrap && vcpWrap.getAttribute('data-vcp-track');
    var item = { id: id, quantity: 1 };
    if (vcpSrc) item.properties = { _src: vcpSrc };
    // Plain window.fetch on purpose — the cart bridge intercepts it and
    // takes care of the drawer refresh/open and all reconciliation.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .catch(function () { /* noop */ })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = prevLabel;
          btn.style.width = '';
        }, 4000);
      });
  });
})();
